<template>
  <div class=''>
    <baidu-map class="map"
      ak="gD0US3DRGOhKvNVgISDCeCQiAWu75E1H"
      style="height: 100vh;width:100%;"
      :center="position"
      :zoom="18">
      <bm-marker :position="position"
        :dragging="true"
        animation="BMAP_ANIMATION_BOUNCE">
        <!-- <bm-label content="我爱北京天安门" :labelStyle="{color: 'red', fontSize : '24px'}" :offset="{width: -35, height: 30}"/> -->
      </bm-marker>
      <!-- <bm-polyline :path="polylinePath"
        stroke-color="#259545"
        :stroke-opacity="0.5"
        :stroke-weight="2"></bm-polyline> -->
      <!-- </div> -->

    </baidu-map>
    <div style="width:100%;">
      <van-button round
        @click="getAddress"
        style="position: absolute;bottom: 15px;width: 90%;margin: 0 5%;"
        type="info">获取当前位置</van-button>
    </div>

  </div>
</template>

<script>

import wx from "weixin-js-sdk";
import { Dialog } from 'vant';
import Vue from 'vue';
import { Toast } from 'vant';
import { getToken, setToken } from "@/utils/auth";
import { getNewTrack } from "@/api/Lycal";
Vue.use(Toast);
export default {
  name: '',
  data () {
    return {
      snId: '',
      polylinePath: [
        { lng: 112.5689279, lat: 34.904358 },
      ],
      position: { lng: 112.5689279, lat: 34.904358 },
    };
  },
  created () {
    setToken(this.$route.query["token"]);
    this.snId = this.$route.query["sn"]
    this.getAddress()
  },
  methods: {
    getAddress () {
      // console.log(this.snId);
      // console.log(getToken());
      getNewTrack({ imei: this.snId }).then((res) => {
        if (res.data.code == 0) {
          // console.log(res.data.data.items[0]);
          this.position = { lng: res.data.data.items[0].lng, lat: res.data.data.items[0].lat }
        }
      })
    },

  }
}
</script>
<style lang='less' scoped>
</style>